module.exports = __webpack_public_path__ + "img/flux-icon.7430073c.png";